import { types } from "./actions";
import {
  encryptEstandar,
} from "../../Utils/CryptographyUtils";

const initialState = {
  valuesPdf: [],
  valuesPdfRI: [],
  valuesPdfVAS: [],
  valuesPdfIG: [],
  valuesPdfUC: [],
  responseVAS: {},
  responseIG: {},
  simulatesRI: [],
  portafolio: {},
  btnPdf: true,
  btnPdfRI: true,
  btnPdfVAS: true,
  btnPdfIG: false,
  btnPdfUC: false,
  showSISCO_STATE: false
};

const cotizadorReducer = (state = initialState, action) => {
  const {
    type,
    data,
    dataRI,
    dataVAS,
    dataIG,
    dataUC,
    responseVAS,
    responseIG,
    simulates,
    portafolio,
    updateData,
    updateDataRI,
    updateDataVAS,
    btnPdf,
    btnPdfRI,
    btnPdfVAS,
    btnPdfIG,
    btnPdfUC,
    showSISCO
  } = action;

  switch (type) {
    case types.sendDataForPdf:
      data.firstName = encryptEstandar(data.assured.firstName);
      data.birthday = encryptEstandar(data.assured.birthday);
      data.lastName = encryptEstandar(data.assured.lastName);
      data.names = encryptEstandar(data.assured.names);
      data.nroDoc = encryptEstandar(data.assured.nroDoc);
      data.userName = encryptEstandar(data.assured.userName);
      data.typeDoc = encryptEstandar(data.assured.typeDoc);
      let valuesPdf = state.valuesPdf.concat([data]);
      return {
        ...state,
        valuesPdf,
      };
    case types.updateDataForPdf:
      return {
        ...state,
        valuesPdf: updateData,
      };
    case types.cleanDataTable:
      return {
        ...state,
        valuesPdf: [],
        btnPdf: true,
      };
    case types.updateBtnPdf:
      return {
        ...state,
        btnPdf,
      };
    case types.updateShowSisco:
      return {
        ...state,
        showSISCO_STATE: showSISCO
      }
    case types.sendDataForPdfRI:
      dataRI.birthday = encryptEstandar(dataRI.birthday);
      dataRI.firstName = encryptEstandar(dataRI.firstName);
      dataRI.lastName = encryptEstandar(dataRI.lastName);
      dataRI.names = encryptEstandar(dataRI.names);
      dataRI.nroDoc = encryptEstandar(dataRI.nroDoc);
      dataRI.userLogin = encryptEstandar(dataRI.userLogin);
      let valuesPdfRI = state.valuesPdfRI.concat([dataRI]);
      return {
        ...state,
        valuesPdfRI,
      };
    case types.updateDataForPdfRI:
      return {
        ...state,
        valuesPdfRI: updateDataRI,
      };
    case types.cleanDataTableRI:
      return {
        ...state,
        valuesPdfRI: [],
        simulatesRI: [],
        btnPdfRI: true,
      };
    case types.updateBtnPdfRI:
      return {
        ...state,
        btnPdfRI,
      };
    case types.sendDataForPdfVAS:
      dataVAS.firstName = encryptEstandar(dataVAS.assured.firstName);
      dataVAS.birthday = encryptEstandar(dataVAS.assured.birthday);
      dataVAS.lastName = encryptEstandar(dataVAS.assured.lastName);
      dataVAS.names = encryptEstandar(dataVAS.assured.names);
      dataVAS.nroDoc = encryptEstandar(dataVAS.assured.nroDoc);
      dataVAS.typeDoc = encryptEstandar(dataVAS.assured.typeDoc);
      dataVAS.userLogin = encryptEstandar(dataVAS.userLogin);
      let valuesPdfVAS = state.valuesPdfVAS.concat([dataVAS]);

      return {
        ...state,
        valuesPdfVAS,
      };
    case types.updateDataForPdfVAS:
      return {
        ...state,
        valuesPdfVAS: updateDataVAS,
      };
    case types.cleanDataTableVAS:
      return {
        ...state,
        valuesPdfVAS: [],
        btnPdfVAS: true,
      };
    case types.updateBtnPdfVAS:
      return {
        ...state,
        btnPdfVAS,
      };
    case types.selectResponseVAS:
      return {
        ...state,
        responseVAS,
      };
    case types.selectResponseIG:
      return {
        ...state,
        responseIG,
      };
    case types.sendDataForPdfIG:
      dataIG.firstName = encryptEstandar(dataIG.assured.firstName);
      dataIG.birthday = encryptEstandar(dataIG.assured.birthday);
      dataIG.lastName = encryptEstandar(dataIG.assured.lastName);
      dataIG.names = encryptEstandar(dataIG.assured.names);
      dataIG.nroDoc = encryptEstandar(dataIG.assured.nroDoc);
      dataIG.typeDoc = dataIG.assured.typeDoc;
      dataIG.userLogin = encryptEstandar(dataIG.userLogin);
      let valuesPdfIG = state.valuesPdfIG.concat([dataIG]);
      return {
        ...state,
        valuesPdfIG,
      };
    case types.cleanDataTableIG:
      return {
        ...state,
        valuesPdfIG: [],
        btnPdfIG: false,
      };
    case types.updateBtnPdfIG:
      return {
        ...state,
        btnPdfIG,
      };
    case types.sendDataForPdfUC:
      dataUC.firstName = encryptEstandar(dataUC.assured.firstName);
      dataUC.birthday = encryptEstandar(dataUC.assured.birthday);
      dataUC.lastName = encryptEstandar(dataUC.assured.lastName);
      dataUC.names = encryptEstandar(dataUC.assured.names);
      dataUC.nroDoc = encryptEstandar(dataUC.assured.nroDoc);
      dataUC.typeDoc = dataUC.assured.typeDoc;
      dataUC.userLogin = encryptEstandar(dataUC.userLogin);
      let valuesPdfUC = state.valuesPdfUC.concat([dataUC]);
      return {
        ...state,
        valuesPdfUC,
      };
    case types.cleanDataTableUC:
      return {
        ...state,
        valuesPdfUC: [],
        btnPdfIG: false,
      };
    case types.updateBtnPdfUC:
      return {
        ...state,
        btnPdfUC,
      };
    case types.saveSimulates:
      let arrayS = state.simulatesRI;
      let existSimulate = arrayS.filter((i) => i.id == simulates.id);

      if (existSimulate.length > 0) {
        let index = arrayS.indexOf(existSimulate[0]);
        arrayS.splice(index, 1);
        let simulatesRI = [...arrayS, simulates];
        return {
          ...state,
          simulatesRI,
        };
      } else {
        let simulatesRI = [...state.simulatesRI, simulates];
        return {
          ...state,
          simulatesRI,
        };
      }
    case types.saveConfigProduct:
      return {
        ...state,
        portafolio,
      };
    case types.cleanConfigProduct:
      return {
        ...state,
        portafolio: {},
      };

    default:
      return {
        ...state,
      };
  }
};
export default cotizadorReducer;
